import { render, staticRenderFns } from "./AgeConfirm.vue?vue&type=template&id=d5385bf6&scoped=true&"
import script from "./AgeConfirm.vue?vue&type=script&lang=ts&"
export * from "./AgeConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./AgeConfirm.vue?vue&type=style&index=0&id=d5385bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5385bf6",
  null
  
)

export default component.exports